import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCalculationRoundingUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const RoundingUnitSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCalculationRoundingUnit, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCalculationRoundingUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `ROUNDING_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default RoundingUnitSelect;
